export default __webpack_public_path__ + "static/media/Neter.bb8ee97a.jpg";